import gql from 'graphql-tag'

const ATTACHMENT_FIELDS = gql`
  fragment AttachmentFields on Attachment {
    id
    type
    url
    dateCreated
    name
    mimeType
    requirementId
  }
`
export const REQUIREMENT_FIELDS = gql`
  ${ATTACHMENT_FIELDS}
  fragment RequirementFields on Requirement {
    id
    description
    creatorId
    created
    updated
    releaseNo
    sortkey
    done
    version
    creator {
      firstname
      lastname
      id
    }
    attachments {
      ...AttachmentFields
    }
    cardTypeId
    cardType {
      id
      title
      triggerType
      queryType
      aggregateType
      gwtType
      color {
        red
        green
        blue
      }
    }
    comments {
      id
      author {
        id
        firstname
        lastname
      }
      text
      dateCreated
      dateUpdated
      generatedByAi
    }
    reactions {
      direction
      user {
        id
        firstname
        lastname
      }
    }
    assignee {
      id
      firstname
      lastname
    }
    boundedContext
    entityId
    cardinality
  }
`

export const WORKFLOW_FIELDS = gql`
  ${REQUIREMENT_FIELDS}
  fragment WorkflowFields on Workflow {
    id
    projectId
    name
    accessLevel
    version
    lanesVersion
    sameAsVersion
    status
    updatedAt
    starred
    aiDescription
    aiVersion
    updateNote {
      userRealName
      action
      target
    }
    lanes {
      id
      name
    }
    eventDefinition {
      title
      description
      color {
        red
        green
        blue
        rgb
      }
    }
    roleDefinition {
      title
      description
      color {
        red
        green
        blue
        rgb
      }
    }
    eventsJson {
      id
      laneId
      groupId
      description
      type
      conditionLabel
      version
      conditionLabels {
        parentId
        name
      }
      parents
      offset
      subprocess {
        id
        name
      }
      dataModels {
        name
        type
        cardId
        dataFields {
          name
          cardinality
          exampleData
          relatedEntityId
          type
          tags
          hideInForm
          dataFields {
            name
            type
          }
        }
      }
      color {
        red
        green
        blue
        rgb
      }
      requirementsJson {
        ...RequirementFields
      }
    }
    dataModels {
      id
      name
      type
      boundedContext
      connectedToEvents
      dataFields {
        name
        exampleData
        cardinality
        relatedEntityId
        primaryKey
        reference
        type
        tags
        hideInForm
      }
    }
    boundedContexts {
      id
      name
      templateId
      githubAccountLogin
      githubRepo
      githubBranch
    }
    groups {
      id
      name
      startSlotX
    }
    canAppliconExport
  }
`
